// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app__InstallmentsPopup__headerunderline{text-decoration:underline}", "",{"version":3,"sources":["webpack://./../common/capabilities-react/twia-capability-quoteandbind-TWIAResidential-react/components/InstallmentsPopup/InstallmentsPopup.module.scss"],"names":[],"mappings":"AAAA,yCACI,yBAAA","sourcesContent":[".headerunderline{\r\n    text-decoration: underline;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"headerunderline": "app__InstallmentsPopup__headerunderline"
};
export default ___CSS_LOADER_EXPORT___;
